import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { PermissionsErrorResolver } from './PermissionsErrorResolver'

interface Props {
  statusCode: number
  errorCode?: string
  errorMessage?: string
}

const PermissionsBanner = ({ statusCode, errorCode, errorMessage }: Props) => {
  const resolver = new PermissionsErrorResolver(statusCode, errorCode, errorMessage)

  return (
    <>
      {resolver.shouldShow && (
        <Box
          flexDirection="column"
          justifyContent="flexStart"
          padding="s24"
          borderRadius={{ all: 'abs016' }}
          background="radicalRed100"
          gap="s8"
        >
          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
            <Text size="200" weight="bold">
              {i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.title'
              )}
            </Text>
          </Box>

          <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
            <Text size="200">{resolver.description}</Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default PermissionsBanner
